module.exports = __webpack_public_path__ + "img/abcam-login_02.9b8e4cd2.png";